import * as React from "react";
import { DecorateEditorialHtml } from "../../../ContentUtilities";
import { UitkText } from "uitk-react-text";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";

const CONTENT_ID_COUNT = 4;
export const CardComparisonAddedBenefitsEditorial = (props: { items: EditorialModel[] }) => {
  const { items } = props;

  if (items.length !== CONTENT_ID_COUNT) {
    return null;
  }

  const [
    feeCardAddedBenefitsIcon,
    feeCardAddedBenefitsOne,
    feeCardAddedBenefitsTwo,
    feeCardAddedBenefitsThree,
  ] = React.useMemo(() => items.map((item) => <DecorateEditorialHtml key={item.id} text={item.text} />), []);

  return (
    <div className="uitk-type-center xl-l-padding-twelve l-l-padding-twelve m-x-padding-twelve xl-l-margin-six l-l-margin-six m-x-margin-twelve">
      <UitkLayoutGrid>
        <UitkLayoutGridItem className="all-t-padding-three">
          <UitkLayoutFlex space="three" alignItems="center">
            <UitkLayoutFlexItem>
              <div>{feeCardAddedBenefitsIcon}</div>
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem>
              <div>
                <UitkText size={300} weight="medium" align="left">
                  {feeCardAddedBenefitsOne}
                </UitkText>
              </div>
            </UitkLayoutFlexItem>
          </UitkLayoutFlex>
        </UitkLayoutGridItem>
        <UitkLayoutGridItem className="all-t-padding-three">
          <UitkLayoutFlex space="three" alignItems="center">
            <UitkLayoutFlexItem>
              <div>{feeCardAddedBenefitsIcon}</div>
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem>
              <div>
                <UitkText size={300} weight="medium" align="left">
                  {feeCardAddedBenefitsTwo}
                </UitkText>
              </div>
            </UitkLayoutFlexItem>
          </UitkLayoutFlex>
        </UitkLayoutGridItem>
        <UitkLayoutGridItem className="all-t-padding-three all-b-padding-six">
          <UitkLayoutFlex space="three" alignItems="center">
            <UitkLayoutFlexItem>
              <div>{feeCardAddedBenefitsIcon}</div>
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem>
              <div>
                <UitkText size={300} weight="medium" align="left">
                  {feeCardAddedBenefitsThree}
                </UitkText>
              </div>
            </UitkLayoutFlexItem>
          </UitkLayoutFlex>
        </UitkLayoutGridItem>
      </UitkLayoutGrid>
    </div>
  );
};

export default CardComparisonAddedBenefitsEditorial;
